var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"rounded-full overflow-hidden",style:({
      width: _vm.width,
      height: _vm.height,
      minWidth: _vm.width,
      minHeight: _vm.height
    })},[(!_vm.isError)?_c('img',{key:_vm.isError,attrs:{"src":_vm.src},on:{"error":function($event){_vm.isError = true}}}):_c('div',{staticClass:"bg-primary-default h-full w-full grid place-items-center text-center text-neutral-white font-weight-bold"},[_vm._v(" "+_vm._s(_vm.initials ? _vm.initialsName : _vm.name)+" ")])]),(_vm.hasDetail)?_c('div',{staticClass:"px-3"},[_c('h3',{staticClass:"text-lg"},[_vm._v(_vm._s(_vm.name))]),_c('div',[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }